import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import ApplicationsContent from "./ApplicationsContent/ApplicationsContent";
import { Values } from "@src/Tools/Values";
import { IValuesStore } from "@src/Stores/Values/types";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class Applications extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getApplicationLinks(),
        this.props.management.getActivePositions(),
        this.props.management.getActiveLocations(),
        this.props.management.getBaseApplicationLinks(this.props.values.knownApplications.UserManagement),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("applications");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <React.Fragment>{this.isLoading ? <div /> : <ApplicationsContent />}</React.Fragment>;
  }
}

export default Applications;
